import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from './core/core.module';
import { ExemploJestComponent } from './exemplo-jest/exemplo-jest.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AgendaEduModule } from 'agenda-edu';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { Error404Component } from './pages/errors/error404/error404.component';
import { Error500Component } from './pages/errors/error500/error500.component';
import { FaturaService } from './../services/fatura.service';
import { FaturaDetalharComponent } from './pages/fatura/fatura-detalhar/fatura-detalhar.component';
import { FaturaListarComponent } from './pages/fatura/fatura-listar/fatura-listar.component';
import { ComponentesListarComponent } from './pages/componentes/componentes-listar/componentes-listar.component';
import { FaturaSemPermissaoComponent } from './pages/fatura/fatura-sem-permissao/fatura-sem-permissao.component';
import { EaeFichaFinanceiraComponent } from './pages/fatura/components/eae-ficha-financeira/eae-ficha-financeira.component';
import { EaeFaturaCardComponent } from './pages/fatura/components/eae-fatura-card/eae-fatura-card.component';
import { EaeFaturaDetalhesComponent } from './pages/fatura/components/eae-fatura-detalhes/eae-fatura-detalhes.component';
import { EaeNavFaturaDetalhadaComponent } from './pages/fatura/components/eae-nav-fatura-detalhada/eae-nav-fatura-detalhada.component';
import { APP_BASE_HREF } from '@angular/common';
import { ConhecaPortalComponent } from './pages/conheca-portal/conheca-portal.component';
import { FaturaEscolhaPagamentoComponent } from './pages/fatura/fatura-escolha-pagamento/fatura-escolha-pagamento.component';
import { EaeFaturaEscolhaPagamentoComponent } from './pages/fatura/components/eae-fatura-escolha-pagamento/eae-fatura-escolha-pagamento.component';
import { FaturaDetalharPixComponent } from './pages/fatura/fatura-detalhar-pix/fatura-detalhar-pix.component';
import { EaeNavFaturaDetalhadaPixComponent } from './pages/fatura/components/eae-nav-fatura-detalhada-pix/eae-nav-fatura-detalhada-pix.component';


const routes = [
  {
    path: 'soma',
    component: ExemploJestComponent,
  },
  { path: '**', redirectTo: '/' },
];

@NgModule({
  declarations: [
    AppComponent,
    ComponentesListarComponent,
    ExemploJestComponent,
    Error404Component,
    Error500Component,
    FaturaDetalharComponent,
    FaturaListarComponent,
    FaturaSemPermissaoComponent,
    EaeFichaFinanceiraComponent,
    EaeFaturaCardComponent,
    EaeFaturaDetalhesComponent,
    EaeNavFaturaDetalhadaComponent,
    ConhecaPortalComponent,
    FaturaEscolhaPagamentoComponent,
    EaeFaturaEscolhaPagamentoComponent,
    FaturaDetalharPixComponent,
    EaeNavFaturaDetalhadaPixComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    CoreModule,
    SharedModule,
    RouterModule.forRoot(routes),
    FormsModule,
    AgendaEduModule,
    AppRoutingModule,
  ],
  providers: [FaturaService, {provide: APP_BASE_HREF, useValue: '/'}],
  bootstrap: [AppComponent],
})
export class AppModule {}
